<template>
  <BaseDialog
    ref="baseDialog"
    modal-id="deleteSubjectDialog"
    title="حذف المادة"
    confirm-text="حذف"
    confirm-variant="danger"
    @confirm="handleConfirm"
  >
    <template #body>
      <p>هل أنت متأكد أنك تريد حذف المادة <strong>{{ subjectName }}</strong>؟</p>
      <p class="text-danger">لا يمكن التراجع عن هذا الإجراء.</p>
    </template>
  </BaseDialog>
</template>

<script setup>
import { ref, defineEmits, defineExpose } from 'vue';
import BaseDialog from '@/components/common/BaseDialog.vue';

const baseDialog = ref(null);
const subjectName = ref('');
const subjectId = ref(null);

const open = (subject) => {
  subjectName.value = subject.name;
  subjectId.value = subject.id;
  baseDialog.value?.openDialog();
};

const emit = defineEmits(['delete']);

const handleConfirm = () => {
  emit('delete', subjectId.value);
  baseDialog.value?.closeDialog();
};

defineExpose({ open });
</script>